import React, { Component } from "react";
import { injectIntl, InjectedIntlProps } from "react-intl";
import { service, actions } from "./data";
import { preventBubbleUp } from "~/admin/utils";
import { withMasked, withNewApiResult, withValidateImportResults, withCrud } from "~/hocs";
// Components
import AddEditPanel from "./add-edit/add-edit-container";
import { ImportExportHeader } from "../components/import-export-header";
import { DataTable, DialogBox, Button } from "~/core";
import { TraitLog } from "./trait-log";
import { messages } from "../i18n-messages";
import SlidingPanel from "~/sliding-panel/sliding-panel";
// types
import { IDataTableFooterOptions } from "~/core/components/tables/interfaces";
import { IAgBytesProps, IAgBytesState } from "../interfaces";

export class Trait_ extends Component<
    IAgBytesProps<typeof actions, typeof AddEditPanel> & InjectedIntlProps,
    IAgBytesState
> {
    tableFooterOptions: IDataTableFooterOptions[];
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.tableFooterOptions = [
            {
                label: "Delete Selected",
                action: this.props.deleteSelected,
            },
        ];
    }
    onToggleModalClick = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    render() {
        const { formatMessage } = this.props.intl;
        const { showAddEditPanel } = this.props.addEditPanel;
        let slidingPanelProps = { ...this.props };
        if (showAddEditPanel) {
            slidingPanelProps = {
                ...slidingPanelProps,
                ...this.props.addEditPanel,
            };
        }
        return (
            <div className="content-table-container">
                <ImportExportHeader
                    {...this.props}
                    service={service}
                    onToggleModalClick={this.onToggleModalClick}
                    onToggleActiveClick={service.toggleColumnVisibility}
                />
                <DataTable
                    isEditable
                    isCheckbox
                    service={service}
                    messages={messages}
                    {...this.props}
                    footerOptions={this.tableFooterOptions}
                />
                {!showAddEditPanel ? null : (
                    <form onSubmit={(event) => preventBubbleUp(event)}>
                        <SlidingPanel
                            {...slidingPanelProps}
                            close={this.props.closeSidePanel}
                            component={AddEditPanel}
                            navigateTo={{
                                parentNameCode: "102",
                                childNameCode: "179",
                            }}
                        >
                            <Button type="save" forceSubmit onClick={() => this.props.onSubmit()} />
                            <Button type="cancel" onClick={() => this.props.closeSidePanel()} />
                        </SlidingPanel>
                    </form>
                )}
                <DialogBox
                    className="view-log-dialog-box"
                    isOpen={this.state.isModalOpen}
                    draggable
                    unrestricted
                    onClose={() => this.onToggleModalClick()}
                    title={formatMessage(messages.traitLogHistory)}
                >
                    <TraitLog needs={this.props.needs} />
                </DialogBox>
            </div>
        );
    }
}
export const Trait = injectIntl(
    withMasked(
        withNewApiResult(
            withValidateImportResults(withCrud(Trait_, service, actions, true), actions.importData)
        )
    )
);
